export function isValidName(name: string): boolean {
  const nameRegex = /^[A-Za-z\s]+$/;
  return nameRegex.test(name);
}

export function thousandsSeparator(value: string | number): string {
  if (value === undefined || value === null || value === "") return value;
  const valueStr = String(value);
  if (isNaN(Number(valueStr))) return value;
  if (valueStr.includes(".")) {
    const [integer, decimal] = valueStr.split(".");
    return `${integer.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}.${decimal}`;
  } else return valueStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function stripCurrencyFormatting(value: string): string {
  return value?.replace(/[$,]/g, "").trim();
}

export function thousandsSeparatorForCurrency(value?: string | number): string {
  if (value === undefined || value === null || value === "") {
    return "";
  }

  // Convert to a string and remove existing commas
  const stringValue = String(value).replace(/,/g, "");

  // Check if the value is a valid number
  const num = Number(stringValue);
  if (isNaN(num)) {
    return stringValue;
  }

  // Handle cases where the user is typing a decimal
  const [integer, decimal] = stringValue.split(".");

  // Add commas to the integer part
  const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // Return the integer part, preserving the decimal part if it exists
  return decimal !== undefined
    ? `${formattedInteger}.${decimal}`
    : formattedInteger;
}
